var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 582.315,
    height: 289,
    viewBox: "0 0 582.315 289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Feature-5-svg-a",
    x: 0,
    y: 0,
    width: 138.315,
    height: 156,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-5-svg-c",
    x: 148,
    y: 0,
    width: 138.315,
    height: 156,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-5-svg-e",
    x: 296,
    y: 0,
    width: 138.315,
    height: 156,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-5-svg-g",
    x: 444,
    y: 0,
    width: 138.315,
    height: 156,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-5-svg-i",
    x: 74,
    y: 133,
    width: 138.315,
    height: 156,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-5-svg-k",
    x: 222,
    y: 133,
    width: 138.315,
    height: 156,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.158 10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.16, -10)",
    filter: "url(#Feature-5-svg-a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.16 10)",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 135.4640960693359 L 64.5 134.5980834960938 L 7.342319965362549 101.5980834960938 L 5.842319965362549 100.732063293457 L 5.842319965362549 99 L 5.842319965362549 33 L 5.842319965362549 31.26794052124023 L 7.342319965362549 30.40192031860352 L 64.5 -2.598079919815063 L 66 -3.464099884033203 L 67.5 -2.598079919815063 L 124.6576766967773 30.40192031860352 L 126.1576766967773 31.26794052124023 L 126.1576766967773 33 L 126.1576766967773 99 L 126.1576766967773 100.732063293457 L 124.6576766967773 101.5980834960938 L 67.5 134.5980834960938 L 66 135.4640960693359 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66 0 L 8.842315673828125 33 L 8.842315673828125 99 L 66 132 L 123.1576843261719 99 L 123.1576843261719 33 L 66 0 M 66 -5.999984741210938 C 67.03589630126953 -5.999984741210938 68.07179260253906 -5.732040405273438 69 -5.196151733398438 L 126.1576843261719 27.80384063720703 C 128.0140991210938 28.87565612792969 129.1576843261719 30.85640716552734 129.1576843261719 33 L 129.1576843261719 99 C 129.1576843261719 101.1435928344727 128.0140991210938 103.1243438720703 126.1576843261719 104.1961517333984 L 69 137.1961517333984 C 68.07179260253906 137.7320404052734 67.03589630126953 138 66 138 C 64.96410369873047 138 63.92819976806641 137.7320404052734 63 137.1961517333984 L 5.842315673828125 104.1961517333984 C 3.98590087890625 103.1243438720703 2.842315673828125 101.1435928344727 2.842315673828125 99 L 2.842315673828125 33 C 2.842315673828125 30.85640716552734 3.98590087890625 28.87565612792969 5.842315673828125 27.80384063720703 L 63 -5.196151733398438 C 63.92819976806641 -5.732040405273438 64.96410369873047 -5.999984741210938 66 -5.999984741210938 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44 42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.875,48H1.125A1.126,1.126,0,0,1,0,46.875v-.75A1.126,1.126,0,0,1,1.125,45H5.5A27.37,27.37,0,0,1,8.56,32.353,16.875,16.875,0,0,1,17.654,24,16.876,16.876,0,0,1,8.57,15.661,27.352,27.352,0,0,1,5.5,3H1.125A1.126,1.126,0,0,1,0,1.875v-.75A1.126,1.126,0,0,1,1.125,0h41.75A1.126,1.126,0,0,1,44,1.125v.75A1.126,1.126,0,0,1,42.875,3H38.5a27.373,27.373,0,0,1-3.06,12.648A16.875,16.875,0,0,1,26.346,24a16.873,16.873,0,0,1,9.084,8.338A27.351,27.351,0,0,1,38.5,45h4.375A1.126,1.126,0,0,1,44,46.125v.75A1.126,1.126,0,0,1,42.875,48ZM22,26.25c-3.606,0-7,1.95-9.546,5.492A22.8,22.8,0,0,0,8.5,45h27a22.8,22.8,0,0,0-3.954-13.258C29,28.2,25.606,26.25,22,26.25ZM8.5,3a22.8,22.8,0,0,0,3.954,13.259C15,19.8,18.394,21.75,22,21.75s7-1.95,9.546-5.492A22.8,22.8,0,0,0,35.5,3Zm23,39h-19a1.5,1.5,0,1,1,0-3h19a1.5,1.5,0,1,1,0,3Zm-3-28h-13a1.5,1.5,0,0,1,0-3h13a1.5,1.5,0,0,1,0,3Zm3-5h-19a1.5,1.5,0,1,1,0-3h19a1.5,1.5,0,1,1,0,3Z",
    fill: "#4135af"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -151.16, -10)",
    filter: "url(#Feature-5-svg-c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.16 10)",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 135.4640960693359 L 64.5 134.5980834960938 L 7.342319965362549 101.5980834960938 L 5.842319965362549 100.732063293457 L 5.842319965362549 99 L 5.842319965362549 33 L 5.842319965362549 31.26794052124023 L 7.342319965362549 30.40192031860352 L 64.5 -2.598079919815063 L 66 -3.464099884033203 L 67.5 -2.598079919815063 L 124.6576766967773 30.40192031860352 L 126.1576766967773 31.26794052124023 L 126.1576766967773 33 L 126.1576766967773 99 L 126.1576766967773 100.732063293457 L 124.6576766967773 101.5980834960938 L 67.5 134.5980834960938 L 66 135.4640960693359 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66 0 L 8.842315673828125 33 L 8.842315673828125 99 L 66 132 L 123.1576843261719 99 L 123.1576843261719 33 L 66 0 M 66 -5.999984741210938 C 67.03589630126953 -5.999984741210938 68.07179260253906 -5.732040405273438 69 -5.196151733398438 L 126.1576843261719 27.80384063720703 C 128.0140991210938 28.87565612792969 129.1576843261719 30.85640716552734 129.1576843261719 33 L 129.1576843261719 99 C 129.1576843261719 101.1435928344727 128.0140991210938 103.1243438720703 126.1576843261719 104.1961517333984 L 69 137.1961517333984 C 68.07179260253906 137.7320404052734 67.03589630126953 138 66 138 C 64.96410369873047 138 63.92819976806641 137.7320404052734 63 137.1961517333984 L 5.842315673828125 104.1961517333984 C 3.98590087890625 103.1243438720703 2.842315673828125 101.1435928344727 2.842315673828125 99 L 2.842315673828125 33 C 2.842315673828125 30.85640716552734 3.98590087890625 28.87565612792969 5.842315673828125 27.80384063720703 L 63 -5.196151733398438 C 63.92819976806641 -5.732040405273438 64.96410369873047 -5.999984741210938 66 -5.999984741210938 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,52A4.5,4.5,0,0,1,0,47.5V18.888a4.5,4.5,0,0,1,1.643-3.475C1.8,15.28,3.7,13.752,6,11.9V9A3,3,0,0,1,9,6h4.356l.956-.763C16.44,3.536,19.949,0,24,0c4.073,0,7.615,3.58,9.687,5.237.234.185.569.453.957.763H39a3,3,0,0,1,3,3v2.905c2.287,1.84,4.182,3.366,4.368,3.518A4.5,4.5,0,0,1,48,18.892V47.5A4.5,4.5,0,0,1,43.5,52Z",
    fill: "#794bb4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -299.16, -10)",
    filter: "url(#Feature-5-svg-e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.16 10)",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 135.4640960693359 L 64.5 134.5980834960938 L 7.342319965362549 101.5980834960938 L 5.842319965362549 100.732063293457 L 5.842319965362549 99 L 5.842319965362549 33 L 5.842319965362549 31.26794052124023 L 7.342319965362549 30.40192031860352 L 64.5 -2.598079919815063 L 66 -3.464099884033203 L 67.5 -2.598079919815063 L 124.6576766967773 30.40192031860352 L 126.1576766967773 31.26794052124023 L 126.1576766967773 33 L 126.1576766967773 99 L 126.1576766967773 100.732063293457 L 124.6576766967773 101.5980834960938 L 67.5 134.5980834960938 L 66 135.4640960693359 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66 0 L 8.842315673828125 33 L 8.842315673828125 99 L 66 132 L 123.1576843261719 99 L 123.1576843261719 33 L 66 0 M 66 -5.999984741210938 C 67.03589630126953 -5.999984741210938 68.07179260253906 -5.732040405273438 69 -5.196151733398438 L 126.1576843261719 27.80384063720703 C 128.0140991210938 28.87565612792969 129.1576843261719 30.85640716552734 129.1576843261719 33 L 129.1576843261719 99 C 129.1576843261719 101.1435928344727 128.0140991210938 103.1243438720703 126.1576843261719 104.1961517333984 L 69 137.1961517333984 C 68.07179260253906 137.7320404052734 67.03589630126953 138 66 138 C 64.96410369873047 138 63.92819976806641 137.7320404052734 63 137.1961517333984 L 5.842315673828125 104.1961517333984 C 3.98590087890625 103.1243438720703 2.842315673828125 101.1435928344727 2.842315673828125 99 L 2.842315673828125 33 C 2.842315673828125 30.85640716552734 3.98590087890625 28.87565612792969 5.842315673828125 27.80384063720703 L 63 -5.196151733398438 C 63.92819976806641 -5.732040405273438 64.96410369873047 -5.999984741210938 66 -5.999984741210938 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 49)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#d6e3ff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 50,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 47,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 13)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 18)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 23)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 28)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 33)",
    fill: "#d6e3ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44 41)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#794bb4",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 50,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 47,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 13)",
    fill: "#794bb4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 18)",
    fill: "#794bb4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 23)",
    fill: "#794bb4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 28)",
    fill: "#794bb4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 33)",
    fill: "#794bb4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 33)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#4135af",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 50,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 47,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 13)",
    fill: "#4135af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 18)",
    fill: "#4135af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 23)",
    fill: "#4135af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 28)",
    fill: "#4135af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(8 33)",
    fill: "#4135af"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(444)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -447.16, -10)",
    filter: "url(#Feature-5-svg-g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(447.16 10)",
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66,0l57.158,33V99L66,132,8.842,99V33Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66 0 L 8.842315673828125 33 L 8.842315673828125 99 L 66 132 L 123.1576843261719 99 L 123.1576843261719 33 L 66 0 M 66 -5.999984741210938 C 67.03589630126953 -5.999984741210938 68.07179260253906 -5.732040405273438 69 -5.196151733398438 L 126.1576843261719 27.80384063720703 C 128.0140991210938 28.87565612792969 129.1576843261719 30.85640716552734 129.1576843261719 33 L 129.1576843261719 99 C 129.1576843261719 101.1435928344727 128.0140991210938 103.1243438720703 126.1576843261719 104.1961517333984 L 69 137.1961517333984 C 68.07179260253906 137.7320404052734 67.03589630126953 138 66 138 C 64.96410369873047 138 63.92819976806641 137.7320404052734 63 137.1961517333984 L 5.842315673828125 104.1961517333984 C 3.98590087890625 103.1243438720703 2.842315673828125 101.1435928344727 2.842315673828125 99 L 2.842315673828125 33 C 2.842315673828125 30.85640716552734 3.98590087890625 28.87565612792969 5.842315673828125 27.80384063720703 L 63 -5.196151733398438 C 63.92819976806641 -5.732040405273438 64.96410369873047 -5.999984741210938 66 -5.999984741210938 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66,0l57.158,33V99L66,132,8.842,99V33Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 58)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    rx: 2,
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.2 3.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.989,6.271.129,3.483a.421.421,0,0,1,0-.607L.751,2.27a.448.448,0,0,1,.622,0L3.3,4.148,7.427.126a.448.448,0,0,1,.622,0l.622.607a.421.421,0,0,1,0,.607L3.611,6.271a.448.448,0,0,1-.622,0Z",
    transform: "translate(0 0)",
    fill: "#794bb4"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 82)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    rx: 2,
    transform: "translate(0.8 0.8)",
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    rx: 2,
    transform: "translate(0.8 0.8)",
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 54,
    rx: 3.5,
    transform: "translate(104.5 62.5) rotate(90)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 54,
    rx: 3.5,
    transform: "translate(104.5 86.5) rotate(90)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 54,
    rx: 3.5,
    transform: "translate(104.5 38.5) rotate(90)",
    fill: "#d6e3ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74 133)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -77.16, -143)",
    filter: "url(#Feature-5-svg-i)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.16 143)",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 135.4640960693359 L 64.5 134.5980834960938 L 7.342319965362549 101.5980834960938 L 5.842319965362549 100.732063293457 L 5.842319965362549 99 L 5.842319965362549 33 L 5.842319965362549 31.26794052124023 L 7.342319965362549 30.40192031860352 L 64.5 -2.598079919815063 L 66 -3.464099884033203 L 67.5 -2.598079919815063 L 124.6576766967773 30.40192031860352 L 126.1576766967773 31.26794052124023 L 126.1576766967773 33 L 126.1576766967773 99 L 126.1576766967773 100.732063293457 L 124.6576766967773 101.5980834960938 L 67.5 134.5980834960938 L 66 135.4640960693359 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66 0 L 8.842315673828125 33 L 8.842315673828125 99 L 66 132 L 123.1576843261719 99 L 123.1576843261719 33 L 66 0 M 66 -5.999984741210938 C 67.03589630126953 -5.999984741210938 68.07179260253906 -5.732040405273438 69 -5.196151733398438 L 126.1576843261719 27.80384063720703 C 128.0140991210938 28.87565612792969 129.1576843261719 30.85640716552734 129.1576843261719 33 L 129.1576843261719 99 C 129.1576843261719 101.1435928344727 128.0140991210938 103.1243438720703 126.1576843261719 104.1961517333984 L 69 137.1961517333984 C 68.07179260253906 137.7320404052734 67.03589630126953 138 66 138 C 64.96410369873047 138 63.92819976806641 137.7320404052734 63 137.1961517333984 L 5.842315673828125 104.1961517333984 C 3.98590087890625 103.1243438720703 2.842315673828125 101.1435928344727 2.842315673828125 99 L 2.842315673828125 33 C 2.842315673828125 30.85640716552734 3.98590087890625 28.87565612792969 5.842315673828125 27.80384063720703 L 63 -5.196151733398438 C 63.92819976806641 -5.732040405273438 64.96410369873047 -5.999984741210938 66 -5.999984741210938 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 56,
    rx: 2,
    transform: "translate(94 38) rotate(90)",
    fill: "#de4b35",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 70,
    rx: 2,
    transform: "translate(100 64) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(27 25)",
    fill: "#de4b35",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(20 51)",
    fill: "#4135af",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(98 27)",
    fill: "#de4b35",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "]")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(105 53)",
    fill: "#4135af",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "]")), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 56,
    rx: 2,
    transform: "translate(94 90) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(27 77)",
    fill: "#4135af",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(98 79)",
    fill: "#4135af",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "]"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222 133)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -225.16, -143)",
    filter: "url(#Feature-5-svg-k)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.16 143)",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 135.4640960693359 L 64.5 134.5980834960938 L 7.342319965362549 101.5980834960938 L 5.842319965362549 100.732063293457 L 5.842319965362549 99 L 5.842319965362549 33 L 5.842319965362549 31.26794052124023 L 7.342319965362549 30.40192031860352 L 64.5 -2.598079919815063 L 66 -3.464099884033203 L 67.5 -2.598079919815063 L 124.6576766967773 30.40192031860352 L 126.1576766967773 31.26794052124023 L 126.1576766967773 33 L 126.1576766967773 99 L 126.1576766967773 100.732063293457 L 124.6576766967773 101.5980834960938 L 67.5 134.5980834960938 L 66 135.4640960693359 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66 0 L 8.842315673828125 33 L 8.842315673828125 99 L 66 132 L 123.1576843261719 99 L 123.1576843261719 33 L 66 0 M 66 -5.999984741210938 C 67.03589630126953 -5.999984741210938 68.07179260253906 -5.732040405273438 69 -5.196151733398438 L 126.1576843261719 27.80384063720703 C 128.0140991210938 28.87565612792969 129.1576843261719 30.85640716552734 129.1576843261719 33 L 129.1576843261719 99 C 129.1576843261719 101.1435928344727 128.0140991210938 103.1243438720703 126.1576843261719 104.1961517333984 L 69 137.1961517333984 C 68.07179260253906 137.7320404052734 67.03589630126953 138 66 138 C 64.96410369873047 138 63.92819976806641 137.7320404052734 63 137.1961517333984 L 5.842315673828125 104.1961517333984 C 3.98590087890625 103.1243438720703 2.842315673828125 101.1435928344727 2.842315673828125 99 L 2.842315673828125 33 C 2.842315673828125 30.85640716552734 3.98590087890625 28.87565612792969 5.842315673828125 27.80384063720703 L 63 -5.196151733398438 C 63.92819976806641 -5.732040405273438 64.96410369873047 -5.999984741210938 66 -5.999984741210938 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 46)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.667 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.746,40A3.746,3.746,0,0,1,17.3,39.71,26.94,26.94,0,0,1,5.518,29.363,35.408,35.408,0,0,1,0,10,3.73,3.73,0,0,1,2.313,6.537l15-6.25a3.765,3.765,0,0,1,2.883,0l15,6.25A3.734,3.734,0,0,1,37.5,10a37.23,37.23,0,0,1-1.764,11.544,32.438,32.438,0,0,1-4.382,8.749A27.8,27.8,0,0,1,20.187,39.71,3.738,3.738,0,0,1,18.746,40ZM13.273,17.289a1.587,1.587,0,0,0-1.606,1.563V25.1a1.587,1.587,0,0,0,1.606,1.563H25.06A1.587,1.587,0,0,0,26.667,25.1V18.852a1.587,1.587,0,0,0-1.607-1.563h-.8V14.946a5.092,5.092,0,0,0-10.179,0v2.343Zm5.894,6.771a1.323,1.323,0,0,1-1.34-1.3V21.2a1.34,1.34,0,0,1,2.679,0v1.563A1.323,1.323,0,0,1,19.167,24.06Zm2.41-6.771H16.756V14.946a2.411,2.411,0,0,1,4.821,0v2.343Z",
    transform: "translate(0 0)",
    fill: "#04be9d"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(370 133)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66,0l57.158,33V99L66,132,8.842,99V33Z",
    fill: "none",
    stroke: "#794bb4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    strokeDasharray: "4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,0l57.158,33V99L66,132,8.842,99V33Z",
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature5.a2f6ca0fa495f65b3f3434904018f3c1.svg";
export { ForwardRef as ReactComponent };